export type SortType = 'asc' | 'desc';

export type Sort<T> = {
  type: SortType;
  field: T;
};

const compare = <T>(a: T, b: T): number => {
  if (typeof a === 'string') {
    return a.localeCompare(b as string);
  }
  return (a as number) - (b as number);
};

export const sorting = <T extends Record<string, unknown>>(
  sort: Sort<keyof T>,
  data: T[],
) => {
  return [...data].sort((a, b) => {
    if (sort.type === 'asc') {
      return compare(a[sort.field], b[sort.field]);
    }
    return compare(b[sort.field], a[sort.field]);
  });
};
